/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_4_TitleInputs */

const en_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50 Teacher`)
};

const es_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesor del Top 50 de U.S. Kids Golf`)
};

const de_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-50-Lehrer von U.S. Kids Golf`)
};

const zh_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf 50 强教练`)
};

const ar_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرّب ضمن قائمة U.S. Kids Golf Top 50`)
};

const fr_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignant du Top 50 de U.S. Kids Golf`)
};

const vi_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên thuộc Top 50 của U.S. Kids Golf`)
};

const sw_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu wa Top 50 wa U.S. Kids Golf`)
};

const th_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครู Top 50 ของ U.S. Kids Golf`)
};

const bs_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitelj na listi U.S. Kids Golf Top 50`)
};

const ja_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf トップ50指導者`)
};

const ko_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50 교사`)
};

const pt_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professor Top 50 da U.S. Kids Golf`)
};

const it_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra i 50 migliori insegnanti di U.S. Kids Golf`)
};

const sv_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Topp 50-lärare`)
};

const nl_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50-leraar`)
};

const da_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50-træner`)
};

const nb_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp 50-lærer i U.S. Kids Golf`)
};

const fi_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50 -opettaja`)
};

const pl_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczyciel z listy U.S. Kids Golf Top 50`)
};

const ru_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренер из списка U.S. Kids Golf Top 50`)
};

const tr_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50 Öğretmeni`)
};

const hi_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf टॉप 50 शिक्षक`)
};

const id_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru Top 50 U.S. Kids Golf`)
};

const ms_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru Top 50 U.S. Kids Golf`)
};

const cs_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitel v žebříčku U.S. Kids Golf Top 50`)
};

const el_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δάσκαλος στη λίστα U.S. Kids Golf Top 50`)
};

const he_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה ברשימת Top 50 של U.S. Kids Golf`)
};

const af_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50-onderwyser`)
};

const hu_about_content_honor_1_item_4_title = /** @type {(inputs: About_Content_Honor_1_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Kids Golf Top 50 oktató`)
};

/**
* | output |
* | --- |
* | "U.S. Kids Golf Top 50 Teacher" |
*
* @param {About_Content_Honor_1_Item_4_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_4_title = /** @type {((inputs?: About_Content_Honor_1_Item_4_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_4_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_4_title(inputs)
	if (locale === "de") return de_about_content_honor_1_item_4_title(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_4_title(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_4_title(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_4_title(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_4_title(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_4_title(inputs)
	if (locale === "th") return th_about_content_honor_1_item_4_title(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_4_title(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_4_title(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_4_title(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_4_title(inputs)
	if (locale === "it") return it_about_content_honor_1_item_4_title(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_4_title(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_4_title(inputs)
	if (locale === "da") return da_about_content_honor_1_item_4_title(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_4_title(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_4_title(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_4_title(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_4_title(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_4_title(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_4_title(inputs)
	if (locale === "id") return id_about_content_honor_1_item_4_title(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_4_title(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_4_title(inputs)
	if (locale === "el") return el_about_content_honor_1_item_4_title(inputs)
	if (locale === "he") return he_about_content_honor_1_item_4_title(inputs)
	if (locale === "af") return af_about_content_honor_1_item_4_title(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_4_title(inputs)
	return en_about_content_honor_1_item_4_title(inputs)
});